<template>
    <div class="reach--disclosure reach--payment--banner reach--payment--banner-light"
        style=" font-family: 'Inter', sans-serif; font-size: 10px; border-color: #626264; color: #626264; padding-left: 0.875rem; padding-top: 0.625rem; padding-bottom: 0.625rem; border-radius: 0.5rem; display: flex; margin-top: 0.75rem;background-color: #ffffff">
        <div class="reach--logo"
            style="background-position: center center; background-repeat: no-repeat; background-size: cover; width: 37px; height: 44px; border-color: #626264; border-right: 2px solid #626264; justify-content:flex-end; padding-right: 5px; display: flex;">
            <img src="https://st.rch.how/logos/reach-verified-logo-grey.svg" alt="Reach Verified Badge">
        </div>
        <div class="reach--content" style="padding-left: 10px;">
            <p style=" font-size: 10px; line-height: 1.5;">
                By completing your order, you will check out with our preferred international seller Reach US, CA, UK, EU,
                or AU and agree to the
                <a :href="toSLink()"
                    title="Read Terms of Service" style="color: #626264;">
                    <u>Terms of Service</u></a> of <strong style="font-weight: bold;">Reach</strong>
            </p>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    props: ['goodsType'],
    methods: {
        toSLink() {
            if(this.goodsType && this.goodsType === 'physical') {
                return "https://www.withreach.com/terms-of-service"
            }
            return "https://www.withreach.com/digital-terms-of-service";
        }
    }
    
}


</script>